import { TableCell, TableCellProps } from "@mui/material";
import { TABLE_HEADER_SX } from "@/constants";

interface TableHeaderCellProps extends TableCellProps {
  children: React.ReactNode;
}

export function TableHeaderCell({ children, ...props }: TableHeaderCellProps) {
  return (
    <TableCell sx={TABLE_HEADER_SX} {...props}>
      {children}
    </TableCell>
  );
}
